import "./ResetPassword.scss";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { IoEye, IoEyeOff } from "react-icons/io5";
import { CustomLoadingButton } from "../ui/CustomButton";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
} from "@mui/material";
import newRequest from "../../utils/newRequest";
import { showToast } from "../../toastService";

const ResetPassword = ({ onSuccess }) => {
    const { t } = useTranslation();

    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);

    const [isProcessing, setIsProcessing] = useState(false);
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");


    const [errorExists, setErrorExists] = useState(false);

    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [verifyNewPassword, setVerifyNewPassword] = useState("");

    const [currentPasswordError, setCurrentPasswordError] = useState("");
    const [newPasswordError, setNewPasswordError] = useState("");
    const [verifyPasswordError, setVerifyPasswordError] = useState("");


    const [showCurrentPassword, setShowCurrentPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showVerifyNewPassword, setShowVerifyNewPassword] = useState(false);

    const handleChangePassword = async () => {
        try {

            if (newPassword?.length < 4) {
                setNotifyDialogTitle(t('note'));
                setNotifyDialogText("Password must be at least 5 Characters");
                setIsNotifyDialogOpen(true);
                return;
            }



            if (newPassword !== verifyNewPassword) {
                setNotifyDialogTitle(t('note'));
                setNotifyDialogText("New password does not match");
                setIsNotifyDialogOpen(true);
                return;
            }
            setIsProcessing(true);
            const res = await newRequest.post(
                "/adUser/changePassword",
                {
                    current_password: currentPassword,
                    new_password: newPassword,
                    user_docid: currentUser?._id,
                    action: "changePassword",
                }
            );

            setIsProcessing(false);
            console.log(`changePassword ${JSON.stringify(res.data, null, 2)}`);

            if (res.data?.msg === "success") {
                showToast(t('passwordChanged'), "success");
                // 🔴 call parent to close overlay
                if (onSuccess) onSuccess();
                return;
            } else {
                setNotifyDialogTitle(t('error'));
                setNotifyDialogText(res.data?.text || "Error changing password");
                setIsNotifyDialogOpen(true);
                return;
            }
        } catch (error) {
            setIsProcessing(false);
            console.log(error);
        }
    };



    return (
        <div className="reset-password">
            <div className="input-item-with-label" style={{ position: "relative" }}>
                <label
                    htmlFor="currentPassword"
                    style={{
                        width: "120px",
                    }}
                >
                    {t('currentPassword')}
                </label>
                <input
                    id="currentPassword"
                    name="currentPassword"
                    type={showCurrentPassword ? "text" : "password"}
                    placeholder={t('currentPassword')}
                    value={currentPassword}
                    className="form-input-item"
                    style={{ width: "200px", paddingRight: "30px" }}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                />
                <span
                    onClick={() => setShowCurrentPassword((prev) => !prev)}
                    style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "0.9rem",
                    }}
                >
                    {showCurrentPassword ? <IoEyeOff size={20} color={currentTheme === "light" ? "#000" : "#fff"} /> : <IoEye size={20} color={currentTheme === "light" ? "#000" : "#fff"} />}
                </span>
            </div>
            {currentPasswordError && <span className="error">{currentPasswordError}</span>}
            <div className="input-item-with-label" style={{ position: "relative" }}>
                <label
                    htmlFor="newPassword"
                    style={{
                        width: "120px",
                    }}
                >
                    {t('newPassword')}
                </label>
                <input
                    id="newPassword"
                    name="newPassword"
                    type={showNewPassword ? "text" : "password"}
                    placeholder={t('newPassword')}
                    value={newPassword}
                    className="form-input-item"
                    style={{ width: "200px", paddingRight: "30px" }}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onBlur={(e) => {
                        try {
                            if (e.target.value?.length < 4) {
                                setErrorExists(true);
                                setNewPasswordError("Password must be at least 5 Characters");
                            } else {
                                setErrorExists(false);
                                setNewPasswordError("");
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    }}
                />
                <span
                    onClick={() => setShowNewPassword((prev) => !prev)}
                    style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "0.9rem",
                    }}
                >
                    {showNewPassword ? <IoEyeOff size={20} color={currentTheme === "light" ? "#000" : "#fff"} /> : <IoEye size={20} color={currentTheme === "light" ? "#000" : "#fff"} />}
                </span>
            </div>
            {newPasswordError && <span className="error">{newPasswordError}</span>}
            <div className="input-item-with-label" style={{ position: "relative" }}>
                <label
                    htmlFor="newPassword"
                    style={{
                        width: "120px",
                    }}
                >
                    {t('verify')}
                </label>
                <input
                    id="verifyNewPassword"
                    name="verifyNewPassword"
                    type={showVerifyNewPassword ? "text" : "password"}
                    placeholder={t('verify')}
                    value={verifyNewPassword}
                    className="form-input-item"
                    style={{ width: "200px", paddingRight: "30px" }}
                    onChange={(e) => setVerifyNewPassword(e.target.value)}
                    onBlur={(e) => {
                        try {
                            if (e.target.value !== newPassword) {
                                setErrorExists(true);
                                setVerifyPasswordError("New password does not match");
                            } else {
                                setErrorExists(false);
                                setVerifyPasswordError("");
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    }}
                />
                <span
                    onClick={() => setShowVerifyNewPassword((prev) => !prev)}
                    style={{
                        position: "absolute",
                        right: "8px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        fontSize: "0.9rem",
                    }}
                >
                    {showVerifyNewPassword ? <IoEyeOff size={20} color={currentTheme === "light" ? "#000" : "#fff"} /> : <IoEye size={20} color={currentTheme === "light" ? "#000" : "#fff"} />}
                </span>
            </div>
            {verifyPasswordError && <span className="error">{verifyPasswordError}</span>}
            <span
                style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-end",
                    alignItems: "center",
                }}
            >
                <CustomLoadingButton
                    currentTheme={currentTheme}
                    onClick={handleChangePassword}
                    disabled={isProcessing || errorExists}
                >
                    {t('changePassword')}
                </CustomLoadingButton>
            </span>
            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
        </div>
    );
};


export default ResetPassword;

